var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_403_4460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_403_4460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9102 16.258C11.9102 15.1536 12.3457 14.0944 13.1209 13.3134C13.8961 12.5325 14.9475 12.0937 16.0438 12.0937H82.1828C83.2792 12.0937 84.3306 12.5325 85.1058 13.3134C85.881 14.0944 86.3165 15.1536 86.3165 16.258V66.2297C86.3165 67.3342 85.881 68.3934 85.1058 69.1743C84.3306 69.9553 83.2792 70.394 82.1828 70.394H16.0438C14.9475 70.394 13.8961 69.9553 13.1209 69.1743C12.3457 68.3934 11.9102 67.3342 11.9102 66.2297V16.258Z",
    stroke: "black",
    strokeWidth: 4.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9102 53.7366H86.3165",
    stroke: "black",
    strokeWidth: 4.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5791 87.0508H65.6486",
    stroke: "black",
    strokeWidth: 4.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8461 70.3933L38.7793 87.0505",
    stroke: "black",
    strokeWidth: 4.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3809 70.3933L59.4477 87.0505",
    stroke: "black",
    strokeWidth: 4.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIcon);
export default __webpack_public_path__ + "static/media/system-icon.2f6b3d067a6b0bfe80a48f331488e169.svg";
export { ForwardRef as ReactComponent };